import {UserErrorCodes, User} from '../libs/types/src';

export const K8S_SUPPRESSED_ERRORS = [
  UserErrorCodes.Default, 
  'error_too_many_failed_tasks',
  UserErrorCodes.DisconnectedAccount,
  UserErrorCodes.SnSubscriptionNotFound,
];

export function getUsersWithErrors(user: User, isAdmin: boolean) {
  if (user.archived) return false;
  if (user.warning_code) return true;
  if (!user.error_code) return false;
  if (user.k8s_support && K8S_SUPPRESSED_ERRORS.includes(user.error_code as UserErrorCodes)) return false;
  if (isAdmin && user.error_code) return true;
  return [
    UserErrorCodes.WrongCredentials,
    UserErrorCodes.LoginCaptcha,
    UserErrorCodes.LoginTwoSteps,
    UserErrorCodes.LoginIdentityRequired,
    UserErrorCodes.LoginEmailVerification,
    UserErrorCodes.NameViolation,
    UserErrorCodes.SnActivateTwoFactorAuth,
    UserErrorCodes.LoginAppVerification,
    UserErrorCodes.SnHasOktaSso,
    UserErrorCodes.UserLanguage,
    UserErrorCodes.SnSurvey,
    UserErrorCodes.NewSnUserIntro,
  ].includes(user.error_code as UserErrorCodes);
}
